<button [ngClass]="className"
  [class.selected]="selected?.includes(channel)"
  class="drv-channel-box"
  (click)="onButtonClick(channel)">
  <img *ngIf="channel; else noChannel"
    [src]="iconPath(channel)">
  <ng-template #noChannel>
    <rmx-icon name="add-line"></rmx-icon>
  </ng-template>
</button>